import React from 'react'

import SEO from "../../components/Head/Social"

import Navigation from '../../components/Landing/Navigation'
import BlogSingle from '../../components/Landing/BlogSingle'
import Footer from '../../components/Landing/Footer'

import matter from 'gray-matter'

export const getStaticPaths = async () => {
	const fs = require('fs')
	const files = fs.readdirSync(`${process.cwd()}/posts`, 'utf-8')
	const paths = files.map(fn => ({params: {slug: fn}}))
	return { paths, fallback: false }
}

export const getStaticProps = async (context) => {
	const slug = context.params.slug
	const fs = require('fs')
	const data = fs.readFileSync(`${process.cwd()}/posts/${slug}/index.md`, { encoding: 'utf-8' })
	return { props: { data } }
}

const BlogSinglePage = ({data}) => {
  const c = matter(data)
  const meta = [{name: `article:published_time`, content: c.data.date}, {name: `article:tag`, content: c.data.tags}]
  return (
    <>
      <SEO title={c.data.title} description={c.data.description} type="article" meta={meta}/>
      <Navigation />
      <BlogSingle post={c}/>
      <Footer />
    </>
  )
}
export default BlogSinglePage
